import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable}     from 'rxjs/Observable';
import { TranslateService } from 'ng2-translate';
const json = require("json!./../../../../resources/properties.json");
import { Element } from '../Element';

@Injectable()
export class DashboardService {

    private token: string;
    private _mainUrl = '/mainData';
    private serverURL: string;
   
    constructor(private _translateService: TranslateService, private http: Http) {
        this.serverURL = json.api_url;
        this.getTokenService();        
    }

    getElementsByPage(page: number) {            

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        var language = this._translateService.currentLang;
        let options = new RequestOptions({ headers: authHeader, body: "" });        

        var url: string;
        if(token == null || token == undefined || token == "") {
            url = `${this._mainUrl}/${language}/${page}`;
        } else {
            url = `${this._mainUrl}/authenticated/${language}/${page}`;
        }

        return this.http.get(this.serverURL + url, options).map(response => response.json().rows as Element[]);

    }

    getElementsUntilPage(page: number) {            

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        var language = this._translateService.currentLang;
        let options = new RequestOptions({ headers: authHeader, body: "" });        

        var url: string;
        if(token == null || token == undefined || token == "") {
            url = `${this._mainUrl}/until/${language}/${page}`;
        } else {
            url = `${this._mainUrl}/until/authenticated/${language}/${page}`;
        }

        return this.http.get(this.serverURL + url, options).map(response => response.json().rows as Element[]);

    }

    getPremiumElementsByPage(page: number) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        
        let options = new RequestOptions({ headers: authHeader, body: "" });        
                
        const url = `${this._mainUrl}/premium/${page}`;       

        return this.http.get(this.serverURL + url, options).map(response => response.json().rows as Element[]);

    }     

    getPremiumElementsByPageWithFilters(page: number, sellerType: string, cities: string, tags: string) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        
        let options = new RequestOptions({ headers: authHeader, body: "" });        
                
        const url = `${this._mainUrl}/premium/filters/${page}/${sellerType}/${cities}/${tags}`;       

        return this.http.get(this.serverURL + url, options).map(response => response.json().rows as Element[]);

    }  

    getElementsByPageWithFilters(page: number, categoryType: string, sellerType: string, cities: string, tags: string, search: string) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        var language = this._translateService.currentLang;
        let options = new RequestOptions({ headers: authHeader, body: "" });

        var url: string;
        if(token == null || token == undefined || token == "") {
            url = `${this._mainUrl}/filters/${language}/${page}/${categoryType}/${sellerType}/${cities}/${tags}/${search}`;
        } else {
            url = `${this._mainUrl}/filters/authenticated/${language}/${page}/${categoryType}/${sellerType}/${cities}/${tags}/${search}`;
        }                    

        return this.http.get(this.serverURL + url, options).map(response => response.json().rows as Element[]);

    }

    getElementsUntilPageWithFilters(page: number, categoryType: string, sellerType: string, cities: string, tags: string, search: string) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        var language = this._translateService.currentLang;
        let options = new RequestOptions({ headers: authHeader, body: "" });

        var url: string;
        if(token == null || token == undefined || token == "") {
            url = `${this._mainUrl}/until/filters/${language}/${page}/${categoryType}/${sellerType}/${cities}/${tags}/${search}`;
        } else {
            url = `${this._mainUrl}/until/filters/authenticated/${language}/${page}/${categoryType}/${sellerType}/${cities}/${tags}/${search}`;
        }

        return this.http.get(this.serverURL + url, options).map(response => response.json().rows as Element[]);

    }

    getElementsCount() {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        
        let options = new RequestOptions({ headers: authHeader, body: "" });        
        
        const url = `${this._mainUrl}/count`;

        return this.http.get(this.serverURL + url, options).map(response => response.json().count);

    }

    sendMessage(messageTitle: string, messageContent: string, messageUserReceiverId: number) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {

            authHeader.append('Authorization', 'Bearer ' + token);

        }
                
        return this.http.post(this.serverURL + this._mainUrl + "/message", this.serializeObj({message_title: messageTitle, message_content: messageContent, message_userReceiverId: messageUserReceiverId}), {headers: authHeader}).toPromise().then(result => {
                    
            return JSON.parse(result.text());

        }).catch(this.handleError);

    }

    getElementsCountWithFilters(categoryType: string, sellerType: string, cities: string, tags: string, search: string) {
        
        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        
        let options = new RequestOptions({ headers: authHeader, body: "" });        
        
        const url = `${this._mainUrl}/filters/count/${categoryType}/${sellerType}/${cities}/${tags}/${search}`;

        return this.http.get(this.serverURL + url, options).map(response => response.json().count);

    }

    getLanguage() {
        return this._translateService.currentLang;
    }

    login(email: string, password: string) {

        let creds = "email=" + email + "&password=" + password;

        return this.http.post(this.serverURL + '/loginData', creds, { headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded'})}).map((res: any) => {
            let data = res.json();
            if (data.token !== undefined) {
                this.token = data.token;
                localStorage.setItem('token', this.token);
            }            
            return data;
        });

    }

    getTokenService() {
        this.token = localStorage.getItem('token');
    }

    getUserName() {
        return localStorage.getItem("userName");
    }

    getUserStatus(): Promise<any> {
        
      let token = localStorage.getItem('token');
        let authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        if (token != null && token != "") {

            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });
            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(res => {
                if (JSON.parse(res.text()).code == -1) {
                    return "guest";
                } else {
                    return JSON.parse(res.text());
                }
            }).catch(this.handleError);
        } else {
            return Promise.resolve({role:"guest"});    
        }

    }

    changeLanguage(lang: string) {
        if (lang == "CAT") {
            this._translateService.currentLang = "cat";
        } else if(lang == "ESP") {
            this._translateService.currentLang = "esp";
        } else if(lang == "ENG") {
            this._translateService.currentLang = "eng";
        }        
    }

    manageFavorite(element_id: number) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {

            authHeader.append('Authorization', 'Bearer ' + token);

        }
        
        
        return this.http.post(this.serverURL + this._mainUrl, this.serializeObj({id: element_id}), {headers: authHeader}).toPromise().then(result => {
        
            return JSON.parse(result.text());            

        }).catch(this.handleError);

    }
               
    private handleError (error:Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }        

    private serializeObj(obj: any) {
        var result: any[] = [];

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/dashboard/dashboard.service.ts
 **/